import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

interface VerCartaModalState {
  isOpen: boolean
  reservaId: number
  codigoReserva: string
}

const initialState: VerCartaModalState = {
  isOpen: false,
  reservaId: 0,
  codigoReserva: '',
}

const verCartaModalSlice = createSlice({
  name: 'verCartaModal',
  initialState,
  reducers: {
    openVerCartaModal(state, action: PayloadAction<{ reservaId: number; codigoReserva: string }>) {
      state.isOpen = true
      state.reservaId = action.payload.reservaId
      state.codigoReserva = action.payload.codigoReserva
    },
    closeVerCartaModal(state) {
      state.isOpen = false
      state.reservaId = 0
      state.codigoReserva = ''
    },
  },
})

export const { openVerCartaModal, closeVerCartaModal } = verCartaModalSlice.actions

const VerCartaModalReducer = verCartaModalSlice.reducer

export default VerCartaModalReducer
